import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TeamEntity } from './team.entity';

/**
 * A classification for teams — "Geographic", "Named Account", "Overlay",
 * "House" (PD-16309).
 *
 * Organizational metadata only: it carries no access of its own. It earns its
 * place once a tenant has overlay teams sitting alongside geographic ones and
 * wants to filter or report on the difference, which is exactly the shape
 * Macomb already has with Engineered Products spanning sixteen branches.
 *
 * Per tenant and freely editable — the names above are the seeded defaults,
 * not an enum.
 */
@Entity('team_type')
export class TeamTypeEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 100 })
	public name!: string;

	/** Display order in pickers and on the team list. Lowest first. */
	@Column('int', { name: 'sortOrder', default: 0 })
	public sortOrder!: number;

	/**
	 * Retired types stay on their teams — history is not rewritten — but drop
	 * out of the pickers.
	 */
	@Column({ type: 'boolean', name: 'isActive', width: 1, default: 1 })
	public isActive!: boolean;

	/**
	 * PD-16364 — a specialty or overlay team (Engineered Products across
	 * many branches): listed in its own section and reported on its own, but
	 * never added into a parent team's totals, because its people's sales are
	 * already counted on their own branch teams.
	 */
	@Column({ type: 'boolean', name: 'isOverlay', width: 1, default: 0 })
	public isOverlay!: boolean;

	@OneToMany(() => TeamEntity, (team) => team.fkTeamType, {})
	public teams!: Array<TeamEntity>;
}
